<template>
  <div v-click-outside="onClickaway" class="tw:w-full tw:flex tw:flex-col">
    <label class="tw:text-sm" for="competitors-search">{{ $t('onboarding_search_title') }}</label>
    <div
      class="tw:flex tw:items-center tw:border tw:border-gray-500 tw:rounded-lg tw:py-[9px] tw:px-3 tw:gap-2 tw:font-base tw:mt-1"
      :class="selectedValues.length >= 5 ? 'tw:bg-gray-200' : 'tw:bg-white'"
    >
      <input
        data-hj-allow
        id="competitors-search"
        type="search"
        :disabled="selectedValues.length >= 5"
        class="tw:focus:outline-hidden tw:grow"
        :placeholder="$t('ri_hotel_search_prompt')"
        :value="searchValue"
        @focus="emit('onFocus')"
        @input="event => emit('onInput', event)"
        @blur="emit('onBlur')"
      />
      <Search class="tw:shrink-0 tw:size-4" />
    </div>

    <template v-if="isOpen">
      <div
        v-if="isSearching === true && searchInput.length > 2"
        class="tw:items-center tw:flex tw:p-5 tw:max-h-[100px]"
      >
        <SmallDotLoader color="#BBBBB9" />
      </div>
      <div
        v-else-if="data && data.length < 1 && searchInput.length === 0"
        class="tw:items-center tw:flex tw:py-2 tw:max-h-[100px]"
      >
        <p class="tw:gray-700 tw:font-bold">{{ $t('rate_insights_search_prompt') }}</p>
      </div>
      <div
        v-else-if="data && data.length < 1 && searchInput.length > 0"
        class="tw:items-center tw:flex tw:py-2 tw:max-h-[100px]"
      >
        <p class="tw:gray-700 tw:font-bold">{{ $t('no_results') }}</p>
      </div>
      <div class="tw:px-5 tw:w-full" v-if="data.length > 0">
        <AccommodationItem
          v-for="item in data"
          :key="item.id"
          :isClickable="true"
          :accommodation="item"
          :location="`${item.city}, ${$t('country_' + item.countryCode?.toLowerCase())}`"
          :values="selectedValues"
          @onSelect="option => onSelect(option)"
        />
      </div>
      <div class="tw:w-full tw:flex tw:flex-col" v-if="suggestions.length && data.length === 0">
        <p class="tw:font-bold tw:bg-gray-100 tw:w-full tw:px-5 tw:py-2">
          {{ $t('suggested_competitors_title') }}
        </p>
        <div class="tw:mt-4 tw:px-5">
          <AccommodationItem
            v-for="suggestion in suggestions"
            :key="suggestion.id"
            :isClickable="true"
            :accommodation="suggestion"
            :location="`${suggestion.city}, ${$t('country_' + suggestion.countryCode?.toLowerCase())}`"
            :values="selectedValues"
            @onSelect="option => onSelect(option)"
          />
        </div>
      </div>
    </template>
  </div>
</template>
<script setup>
import AccommodationItem from '@/components/rateInsights/onboarding/AccommodationItem.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'
import Search from '@/components/icons/Search.svg?component'

defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  suggestions: {
    type: Array,
    default: () => [],
  },
  selectedValues: {
    type: Array,
    default: () => [],
  },
  onClickaway: {
    type: Function,
    default: () => null,
  },
  isSearching: {
    type: Boolean,
  },
  searchInput: {
    type: String,
    default: '',
  },
  searchValue: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['onSelect', 'onInput', 'onFocus', 'onBlur'])
const onSelect = value => emit('onSelect', value)
</script>
